module.exports = __webpack_public_path__ + "fonts/Roboto-400-vietnamese37.3860f0d.woff2";